<script>
import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { validateNumber, validateCurp } from "@/helpers/utils.js";
import { todoMethods, todoComputed } from "@/state/helpers";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Asignación de CURP a tarjeta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      checked: true,
      checked1: false,
      label: "",
      active: 1,
      dataOn: "On",
      dataOff: "Off",
      curp: "",
      folio: "",
      tarjetas: [],
      title: "Asignación de Curp a Tarjeta",
      items: [
        {
          text: "Tarjetas",
          href: "/Tarjetas",
        },
        {
          text: "Nueva Asignación",
          active: true,
        },
      ],
      fetchingStats: true,
      earningStatus: true,
      objeto: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
      }
    };
  },

  computed: {
    ...todoComputed,
    nombreCompleto() {
      return this.objeto.nombre + " " + this.objeto.apellido_paterno + " " + this.objeto.apellido_materno;
    }
  },

  mounted() {
    this.checked = Boolean(this.active);
    this.update();
    this.fetchTodos();
    // this.getTarjetas();
  },

  methods: {
    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,

    // getTarjetas() {
    //   axios.get("http://ec2-18-237-53-89.us-west-2.compute.amazonaws.com:3010/app/tarjetas?request_type=lite").then((res) => {
    //     const { response = "", data = [] } = res.data;
    //     if (response === true) {
    //       const array = [];
    //       data.forEach((t) => {
    //         array.push({ id_tarjeta: t.id_tarjeta, folio: t.folio});
    //       });
    //       this.tarjetas = array;
    //     }
    //   });
    // },


    // method that validate keypress only numbers
    validateNumber(event, value, max) {
      if (value) {
        if (value.toString().length + 1 > max) {
          event.preventDefault();
        } else validateNumber(event);
      } else {
        validateNumber(event);
      }

      axios.get(`https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/tarjetas_filter?folio=${this.folio}`).then((res) => {
        const { response = "", data = [] } = res.data;
        if (response === true) {
          const array = [];
          data.forEach((t) => {
            array.push({ id_tarjeta: t.id_tarjeta, folio: t.folio});
          });
          this.tarjetas = array;
        }
      });
    },
    validateCurp(event, value, max) {
      if (value) {
        if (value.length + 1 > max) {
          event.preventDefault();
        } else validateCurp(event);
      } else {
        validateCurp(event);
      }
    },

    checkCurp() {
      if (this.curp) {
        if (this.curp.length === 18) {
          this.curp = this.curp.toUpperCase();
          axios.get("/mujeres?curp=" + this.curp).then((res) => {
            const { response = "" } = res.data;
            if (response === true) {
              this.objeto = res.data.data
            } else {
              this.$swal("Aviso", res.data.details,"warning");
            }
          })
          .catch((err) => {
            console.log(err)
            this.$swal("Aviso", "No se ha encontrado registro con esa CURP.","warning");
          });
        }  else this.$swal("Aviso", "Ingresa una CURP válida de 18 dígitos","warning");
      } else this.$swal("Aviso", "Favor de ingresar una CURP.","warning");
    },

    checkFolioValid() {
      if (this.folio) {
        // check if folio is in the tarjetas array
        if(!this.tarjetas.find(t => t.folio === this.folio)) {
          this.$swal("Aviso", "El folio ingresado no existe entre las tarjetas disponibles","warning");
          return;
        }
        const tarjeta = this.tarjetas.find((t) => t.folio === this.folio);
        axios.get("/mujeres?id_tarjeta=" + tarjeta.id_tarjeta).then((res) => {
          const { response = "" } = res.data;
          if (response === true) {
            this.$swal("Aviso", "La tarjeta ya tiene asignada una CURP","warning");
            return;
          } else {
            this.handleSubmit();
          }
        }).catch((err) => {
          console.log(err)
          this.handleSubmit();
        });
      } else this.$swal("Aviso", "Favor de seleccionar un folio de tarjeta.","warning");
    },

    handleSubmit() {
      // give me the key of the tarjetas folio
      this.objeto.id_tarjeta = this.tarjetas.find((t) => t.folio === this.folio).id_tarjeta;
      this.objeto.folio_tarjeta = this.folio;
      this.objeto.user_id = localStorage.getItem("user_id");
      axios.put("/usuarios",this.objeto)
        .then((res) => {
          const { response = "" } = res.data;
          if (response === true) {
            this.$swal(
              "Registro",
              "Se ha asignado el folio de tarjeta a la CURP",
              "success"
            );
            this.$router.push("/mujeres");
          } else {
            this.$swal("Alerta", "No se ha podido crear", "warning");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.$swal("Error", "Ocurrio un error", "danger");
        });
    }

    // handleChange() {
      
    // }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <h4 class="card-title">Nueva asignación de CURP a TARJETA</h4>
              </div>
              <div class="col-sm-12 col-md-8">
                <b>
                  <label class="form-check-label">CURP de la mujer</label>
                </b>
                <div class="row mb-2">
                  <div class="col-sm-12 col-md-10">
                    <div>
                      <b-form-input
                        v-model="curp"
                        class="text-uppercase"
                        id="input-curp"
                        placeholder="XXXX000000AAA111"
                        pattern=".{18}"
                        @keypress="validateCurp($event, curp, 18)"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-sm-4 col-md-2">
                    <button class="btn btn-success" @click="checkCurp()">
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
             
              <div class="col-sm-12 col-md-8">
                <b> <label class="form-check-label">Nombre de la mujer</label> </b>
                <div class="mb-4">
                  <b-form-input
                    v-model="nombreCompleto"
                    id="input-mujer"
                    disabled
                  ></b-form-input>
                </div>
              </div>

              <div class="col-sm-12 col-md-8">
                <b><label class="form-check-label">Folio de tarjeta</label></b>
                <div class="mb-4">
                  <b-form-input
                    list="tarjetas_list"
                    v-model="folio"
                    pattern=".{11,}"
                    @keypress="validateNumber($event, folio, 20)"
                    required
                  ></b-form-input>
                  <datalist id="tarjetas_list">
                    <option
                      v-for="tarjeta in tarjetas"
                      :key="tarjeta.id_tarjeta"
                      :value="tarjeta.folio"
                    >
                      {{ tarjeta.folio }}
                    </option>
                  </datalist>
                </div>
              </div>
              <v-row class="mb-4">
                <v-col md="12">
                  <v-btn
                    color="primary"
                    type="button"
                    v-on:click="checkFolioValid()"
                  >
                    Guardar
                  </v-btn>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <router-link to="/Tarjetas">
                    <v-btn color="error" type="button"> Cancelar </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.switch {
  position: relative;
  display: inline-block;
  width: $w;
  height: $h;
  border-radius: 100px;

  .circle {
    display: flex;
    align-items: center;
    width: 100%;
    height: $h - 1;
    border-radius: 100px;
    background-color: $default;

    & > span {
      font-size: $size;
      color: $text;
      padding-left: $h + -6;
    }

    &::before {
      position: absolute;
      content: "";
      height: $circle;
      width: $circle;
      left: 1px;
      top: 1px;
      border-radius: 100px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &:hover {
      background-color: lighten($default, 20);

      & > span {
        color: $text-hover;
      }
    }
  }

  .circle-on {
    background-color: $active;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $active solid;

      &::before {
        background-color: $active;
      }

      & > span {
        color: $active;
      }
    }
  }

  .circle-off {
    background-color: $inactive;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $inactive solid;

      &::before {
        background-color: $inactive;
      }

      & > span {
        color: $inactive;
      }
    }
  }

  & input {
    display: none;

    &:checked + .circle:before {
      -webkit-transform: translateX($toggle-dis);
      -ms-transform: translateX($toggle-dis);
      transform: translateX($toggle-dis);
    }
  }
}
</style>